var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "lm-overlay" }, [
        _c("div", { staticClass: "lm-card" }, [
          _c("div", { staticClass: "lm-head" }, [
            _c("div", { staticClass: "lm-title" }, [
              _c("span", { staticClass: "lm-dot" }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.loginQr.loading ? "正在准备登录…" : "扫码登录企业微信"
                  )
                ),
              ]),
              _vm.loginQr.kind === "screen"
                ? _c("span", { staticClass: "lm-tag" }, [_vm._v("实时屏幕")])
                : _vm._e(),
            ]),
            _c(
              "button",
              {
                staticClass: "lm-x",
                attrs: { title: "关闭窗口" },
                on: { click: _vm.close },
              },
              [_vm._v("✕")]
            ),
          ]),
          _c(
            "div",
            { staticClass: "lm-meta" },
            [
              _vm.loginQr.clientId
                ? [
                    _c("code", [_vm._v(_vm._s(_vm.loginQr.clientId))]),
                    _vm._v(
                      " · " +
                        _vm._s(_vm.loginQr.width) +
                        "×" +
                        _vm._s(_vm.loginQr.height)
                    ),
                  ]
                : [_vm._v("等待设备响应…")],
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "lm-frame" },
            [
              _vm.loginQr.loading
                ? _c("div", { staticClass: "lm-loading" }, [
                    _c("div", { staticClass: "lm-spin" }),
                    _c("div", { staticClass: "lm-loading-t" }, [
                      _vm._v("正在初始化"),
                    ]),
                    _c("div", { staticClass: "lm-loading-s" }, [
                      _vm._v(" 清缓存 + 改机 + 启动企微 + 拉 QR · 约 30 秒 "),
                    ]),
                  ])
                : [
                    _vm.loginQr.pngBase64
                      ? _c("img", {
                          staticClass: "lm-img",
                          attrs: {
                            src:
                              "data:image/png;base64," + _vm.loginQr.pngBase64,
                            alt:
                              _vm.loginQr.kind === "screen"
                                ? "Device Screen"
                                : "QR Login",
                          },
                        })
                      : _c("div", { staticClass: "lm-empty" }, [
                          _vm._v("图像为空（screencap 失败）"),
                        ]),
                  ],
            ],
            2
          ),
          !_vm.loginQr.loading &&
          _vm.loginQr.kind === "screen" &&
          _vm.loginQr.focusedActivity
            ? _c(
                "div",
                {
                  staticClass: "lm-focus",
                  attrs: { title: _vm.loginQr.focusedActivity },
                },
                [
                  _c("span", { staticClass: "lm-focus-l" }, [_vm._v("focus")]),
                  _c("code", [_vm._v(_vm._s(_vm.loginQr.focusedActivity))]),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "lm-tools" }, [
            _c(
              "button",
              {
                staticClass: "lm-ghost",
                attrs: { disabled: _vm.capturingScreen || _vm.loginQr.loading },
                on: { click: _vm.captureDeviceScreen },
              },
              [
                _vm.capturingScreen
                  ? _c("span", { staticClass: "lm-mini-spin" })
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(_vm.capturingScreen ? "刷新中…" : "刷新设备屏幕") +
                    " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "lm-ghost",
                attrs: {
                  disabled: _vm.loginStarting,
                  title: "重头走一遍：清缓存 + 改机 + 拉新 QR",
                },
                on: { click: _vm.startPadQrLogin },
              },
              [
                _vm.loginStarting
                  ? _c("span", { staticClass: "lm-mini-spin" })
                  : _vm._e(),
                _vm._v(
                  " " +
                    _vm._s(_vm.loginStarting ? "重启中…" : "重新生成 QR") +
                    " "
                ),
              ]
            ),
          ]),
          !_vm.loginQr.loading
            ? _c("div", { staticClass: "lm-steps" }, [
                _vm._m(0),
                _vm._m(1),
                _vm._m(2),
              ])
            : _vm._e(),
          _c("div", { staticClass: "lm-input-row" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.loginCodeInput,
                  expression: "loginCodeInput",
                },
              ],
              staticClass: "lm-input",
              class: {
                "lm-input-locked":
                  _vm.loginSubmittedAt !== null || _vm.loginQr.loading,
              },
              attrs: {
                maxlength: "6",
                inputmode: "numeric",
                pattern: "\\d{6}",
                placeholder: "—  —  —  —  —  —",
                readonly: _vm.loginSubmittedAt !== null || _vm.loginQr.loading,
              },
              domProps: { value: _vm.loginCodeInput },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.submitPadSmsCode.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.loginCodeInput = $event.target.value
                },
              },
            }),
            _vm.loginSubmittedAt === null
              ? _c(
                  "button",
                  {
                    staticClass: "lm-submit",
                    attrs: {
                      disabled:
                        _vm.loginSubmitting ||
                        _vm.loginQr.loading ||
                        _vm.loginCodeInput.length !== 6,
                    },
                    on: { click: _vm.submitPadSmsCode },
                  },
                  [
                    _vm.loginSubmitting
                      ? _c("span", {
                          staticClass: "lm-mini-spin lm-mini-spin-w",
                        })
                      : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(_vm.loginSubmitting ? "提交中" : "提交") +
                        " "
                    ),
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "lm-redo",
                    on: {
                      click: function ($event) {
                        _vm.loginSubmittedAt = null
                        _vm.loginResult = null
                      },
                    },
                  },
                  [_vm._v(" 重输 ")]
                ),
          ]),
          _vm.loginSubmittedAt !== null
            ? _c("div", { staticClass: "lm-tip lm-tip-info" }, [
                _c("span", [
                  _vm._v("已下发 "),
                  _c("code", [_vm._v(_vm._s(_vm.loginCodeInput))]),
                  _vm._v("，等待设备确认…"),
                ]),
              ])
            : _vm._e(),
          _vm.loginResult && !_vm.loginResult.success && _vm.loginResult.soft
            ? _c(
                "div",
                { ref: "loginTip", staticClass: "lm-tip lm-tip-warn" },
                [
                  _c("code", [_vm._v(_vm._s(_vm.loginResult.code))]),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.loginResult.error || "（设备未返回详细原因）")
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.loginResult && !_vm.loginResult.success && !_vm.loginResult.soft
            ? _c("div", { ref: "loginTip", staticClass: "lm-tip lm-tip-err" }, [
                _c("code", [_vm._v(_vm._s(_vm.loginResult.code))]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.loginResult.error || "（设备未返回详细原因）")
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("b", [_vm._v("1")]), _vm._v(" 真账号扫码")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("b", [_vm._v("2")]), _vm._v(" 收 6 位短信")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("b", [_vm._v("3")]), _vm._v(" 填入下方提交")])
  },
]
render._withStripped = true

export { render, staticRenderFns }